import { render, staticRenderFns } from "./ReviewLandingPage.vue?vue&type=template&id=7ed7cd40&scoped=true"
import script from "./ReviewLandingPage.vue?vue&type=script&lang=js"
export * from "./ReviewLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewLandingPage.vue?vue&type=style&index=0&id=7ed7cd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed7cd40",
  null
  
)

export default component.exports